import { Component, Input, OnInit } from '@angular/core';
import { AlarmOverview, Application } from '../../../interfaces/alarm';
import { getPumpOptions, getPumpType, systemsToPumpDevice, systemsToValveDevice } from '../../../utils/data-point-utils';
import { DataPointsResult, SystemDevice } from '../../../interfaces/data-points';
import { Observable } from 'rxjs';
import { SchematicsService } from '../../../services/schematics.service';
import { AppModel, CommercialHotWaterSystemState } from '@ams/dumbledore';
import { PumpOption } from 'projects/customerportal/src/app/services/installation-configuration.service';
import { Installation } from '../../../interfaces/facilty';
import { map } from "rxjs/operators";
import { systemHasEnergyValve } from 'projects/dumbledore/src/schematic/util/system-properties-util';
import { PasteurizationStatusTileComponent } from '../../pasteurization-status-tile/pasteurization-status-tile.component';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { SetpointTileComponent } from '../../setpoint-tile/setpoint-tile.component';
import { PumpStatusTileComponent } from '../../pump-status-tile/pump-status-tile.component';
import { ValveStatusTileComponent } from '../../valve-status-tile/valve-status-tile.component';
import { HeatMeterStatusTileComponent } from '../../heat-meter-status-tile/heat-meter-status-tile.component';
import { ForwardReturnChartTileComponent } from '../../charts/forward-return-chart-tile/forward-return-chart-tile.component';
import { ValveChartComponent } from '../../charts/valve-chart/valve-chart.component';
import { EnergyValveHeatAndFlowChartComponent } from '../../charts/energy-valve-heat-and-flow-chart/energy-valve-heat-and-flow-chart.component';
import { EnergyValveTemperatureChartComponent } from '../../charts/energy-valve-temperature-chart/energy-valve-temperature-chart.component';
import { DifferentialPressureChartComponent } from '../../charts/differential-pressure-chart/differential-pressure-chart.component';
import { FlowHeatMeterChartTileComponent } from '../../charts/flow-heat-meter-chart-tile/flow-heat-meter-chart-tile.component';
import { WaterMeterChartTileComponent } from '../../charts/water-meter-chart-tile/water-meter-chart-tile.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-commercial-hot-water-dashboard',
    templateUrl: './commercial-hot-water-dashboard.component.html',
    styleUrls: ['./commercial-hot-water-dashboard.component.scss'],
    imports: [
    PasteurizationStatusTileComponent,
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    SetpointTileComponent,
    PumpStatusTileComponent,
    ValveStatusTileComponent,
    HeatMeterStatusTileComponent,
    ForwardReturnChartTileComponent,
    ValveChartComponent,
    EnergyValveHeatAndFlowChartComponent,
    EnergyValveTemperatureChartComponent,
    DifferentialPressureChartComponent,
    FlowHeatMeterChartTileComponent,
    WaterMeterChartTileComponent,
    TranslateModule,
    AsyncPipe
]
})
export class CommercialHotWaterDashboardComponent implements OnInit {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() public application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;

  public pumpDevice$: Observable<SystemDevice | undefined>;
  public pumpType$: Observable<string>;
  public pumpOptions$: Observable<PumpOption[] | undefined>;
  public valveDevice$: Observable<SystemDevice | undefined>;
  public hasEnergyValve$: Observable<boolean | undefined>;
  public hasPrimaryTemperatureSensors$: Observable<boolean | undefined>;
  private system$: Observable<CommercialHotWaterSystemState>;

  constructor(private schematicsService: SchematicsService) {}

  ngOnInit(): void {
    this.system$ = this.schematic$.pipe(
      map((schematic) => {
        return schematic.systems.find((s) => s.hasId === this.application.id) as CommercialHotWaterSystemState;
      })
    );

    this.pumpDevice$ = this.dataPoints$.pipe(systemsToPumpDevice(this.application.id));

    this.pumpType$ = getPumpType(this.schematic$, this.application.id);

    this.pumpOptions$ = getPumpOptions(this.pumpDevice$, this.schematicsService, this.application.id);

    this.valveDevice$ = this.dataPoints$.pipe(systemsToValveDevice(this.application.id));

    this.hasEnergyValve$ = this.system$.pipe(
      map((system) => {
        return systemHasEnergyValve(system?.systemInfo);
      })
    );

    this.hasPrimaryTemperatureSensors$ = this.system$.pipe(
      map((system) => {
        return (system?.systemInfo.T_PF_present || system?.systemInfo.T_PR_present || system?.systemInfo.HM_present);
      })
    );
  }
}
